import rootUrl from "../url";

export default rootUrl + "kluby/";
